import { useRouteHandleComponent } from '../useRouteHandleComponent';

/**
 * Renders the component named "Action" from the deepest matching route module's "handle" export,
 * passing the "data" property (if any) from that same route handle object as a prop to the component.
 */
export function Action() {
  const result = useRouteHandleComponent({ name: 'Action' });

  if (result === undefined) {
    return null;
  }

  const { Component: RouteAction, data } = result;

  return (
    <div>
      <RouteAction data={data} />
    </div>
  );
}
